// Bandeau d'information de l'offre sélectionnée + lien vers l'offre publique
// Utilisation: <OfferLine title={offerTitle} offerId={offerId} offerUrl={offerUrl} t={t} />
import React from "react";
import { FormIcon } from "./FormIcon";

type Props = {
  title: string | null;
  offerId: string | null;
  offerUrl: string;
  companyLogoUrl?: string | null;
  t: Record<string, string>;
};

export function OfferLine({ title, offerUrl, companyLogoUrl, t }: Props) {
  return (
    <div className="offer-line">
      <div className="offer-heading">
        {companyLogoUrl && (
          <div className="company-logo" aria-hidden="true">
            <img src={companyLogoUrl} alt="" />
          </div>
        )}
        <div className="offer-title">
          <div className="muted">{t.offer}</div>
          <h2>{title || t.offerFallback || t.pageTitle}</h2>
        </div>
      </div>
      <div className="offer-actions">
        <a className="button" href={offerUrl} target="_blank" rel="noreferrer">
          {t.seeOffer}
          <FormIcon name="external" />
        </a>
      </div>
    </div>
  );
}
